import { render, staticRenderFns } from "./statDialog.vue?vue&type=template&id=7fcfbbc5&scoped=true"
import script from "./statDialog.vue?vue&type=script&lang=js"
export * from "./statDialog.vue?vue&type=script&lang=js"
import style0 from "./statDialog.vue?vue&type=style&index=0&id=7fcfbbc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcfbbc5",
  null
  
)

export default component.exports